<template>
  <transition name="loading">
    <div class="loading-page-container" @mousewheel.prevent v-if="loading">
      <div class="logo-container">
        <img
          src="../assets/image/home-logo.png"
          alt=""
          class="animate__animated animate__flipInX"
        />
      </div>

      <div class="loading-container">
        <span class="animate__animated animate__flipInX"
          >Change Starts Now</span
        >
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    show() {
      this.loading = true;
    },
    hide() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// .loading-enter-active,
.loading-leave-active {
  transition: opacity 0.5s;
}
// .loading-enter,
.loading-leave-to {
  opacity: 0;
}
.loading-page-container {
  position: fixed;
  width: 100%;
  min-width: 1240px;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/image/main-background.png");
  background-size: (100%, 100%);
  z-index: 100;
  .logo-container {
    position: absolute;
    z-index: 1000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    img {
      height: 28px;
    }
  }
  .loading-container {
    position: absolute;
    z-index: 999;
    left: 50%;
    bottom: 15%;
    transform: translateX(-50%);
    text-align: center;
    span {
      display: block;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 20px;
    }
    i {
      font-size: 20px;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadingPage.vue